/* eslint-disable no-unused-vars, import/no-duplicates */

/*
Enables immer es6 Map and Set support
  It must be called before `produce` is imported ( `import produce from 'immer';` )
  https://immerjs.github.io/immer/installation/
*/
import { enableMapSet } from 'immer';

enableMapSet();

import set from 'lodash/set';
import produce, { Draft } from 'immer';

/*
setImmutableNestedState
  Accepts context and value generics
  Creates immutable data and sets value at the context object's `path` key
*/
export function setImmutableNestedState<
  ContextGeneric extends { [index: string]: any }, // expect context to be object with string keys
  ValueGeneric,
>(
  setState: React.Dispatch<React.SetStateAction<ContextGeneric>>,
  path: string,
  callback: (newDraft: Draft<ValueGeneric>) => any,
) {
  setState((prevState: ContextGeneric) =>
    set(
      Object.create(prevState),
      path,
      produce(prevState[path], (draft: Draft<ValueGeneric>) => {
        callback(draft);
      }),
    ),
  );
}
